import React from 'react';
import Defect from './defect';

import Auth from '../utils/auth';

class DefectCategory extends React.Component {
  state = {}

  componentDidMount() {
    const { defectCategory } = this.props;
    if(defectCategory) {
      this.setState({ defectCategory });
    } else {
      this.loadDefectCategory();
    }
  }

  loadDefectCategory = () => {
    const { defectCategoryId } = this.props;
    $.ajax({
      url: `/defect-categories/${defectCategoryId}`,
      dataType: 'JSON',
      success: (defectCategory) => {
        this.setState({ defectCategory });
      }
    });
  }

  render() {
    const { summary } = this.props;
    const { defectCategory } = this.state;

    let defects = [];
    
    if(defectCategory) {
      defects = defectCategory.defects;

      if(summary) {
        defects = defects.slice(0, 3);
      }
    }
    
    return (
      <div className='component-defect-category'>
        {
          defectCategory &&
          <React.Fragment>
            <h2>{defectCategory.name}</h2>
            
            
            {
              summary &&
              <div className='view-more-container'>
                <a href={`/defect-categories/${defectCategory.id}`}>View all {defectCategory.name} defects</a>
              </div>
            }
            {
              !summary &&
              <div className='back-container'>
                <a href='/defect-categories/'>Back to all defects</a>
              </div>
            }

            {
              ((Auth.isAdmin() || Auth.isContentEditor()) && !summary) &&
              <div className='add-new-defect-container'>
                <a href={`/defects/new?defect_category_id=${defectCategory.id}`} className='btn'>Add New {defectCategory.name} Defect</a>
              </div>
            }

            <div className='defects'>
              {
                defects.length == 0 ?
                  "Coming soon!"
                :
                  defects.map((defect) => <Defect key={defect.id} defect={defect} />)
              }
            </div>

          </React.Fragment>
        }
      </div>
    );
  }
}

export default DefectCategory;